const getTheme = (themeData) => {return themeData};

export {getTheme}
